import { queryOptions, useQuery } from '@tanstack/react-query';

import { getAccount } from '../api';

// Shared options so the hook and loader-side `ensureQueryData` use the same
// cache entry — the current account is stable per session, fetched once.
export const accountQueryOptions = () =>
  queryOptions({
    queryKey: ['accounts', 'me'],
    queryFn: getAccount,
    staleTime: Infinity,
  });

export const useAccount = () => useQuery(accountQueryOptions());
